export default __webpack_public_path__ + "static/media/advocatespro_logo.79509370.png";